export const translateBase = {
  default: 'uk',
  translate: {
    tooltipAlert: {
      DONT_PUBLISHED: {
        ru: 'Возможно инфоповод еще не опубликован в СМИ.',
        en: 'Perhaps the campaign has not yet been published in the media.',
        uk: 'Можливо інфопривід ще не опублікований в ЗМІ.'
      },
      SAVE_TEXT: {
        ru:
          'Вы можете сохранить данный текст и когда мы найдем его выходы, то сообщим вам!',
        en:
          'You can save this text and when we find its publications, we will inform you!',
        uk:
          'Ви можете зберегти цей текст і коли ми знайдемо його виходи, то повідомимо вам!'
      },
      REDACTOR: {
        ru: 'Если в новости присутствуют лишние фрагменты — удалите их.',
        en: 'If there are extra fragments in the news - delete them.',
        uk: 'Якщо в новині присутні зайві фрагменти - видаліть їх.'
      },
      LESS_TEXT: {
        ru:
          'Мы ищем ваши публикации по тексту и чем меньше лишних элементов присутствует в нем, тем выше точность обнаружения всех выходов.',
        en:
          'We search for your publications by text and the fewer unnecessary elements are present in it, the higher the accuracy of detecting all news.',
        uk:
          'Ми шукаємо ваші публікації по тексту і чим менше зайвих елементів присутніх в ньому, тим вище точність виявлення всіх виходів.'
      }
    },
    menuConfig: {
      DELETE: {
        ru: 'Удалить',
        en: 'Delete',
        uk: 'Видалити'
      },
      RENAME: {
        ru: 'Переименовать',
        en: 'Rename',
        uk: 'Перейменувати'
      },
      HTML: {
        ru: 'HTML',
        en: 'HTML',
        uk: 'HTML'
      },
      PDF: {
        ru: 'PDF',
        en: 'PDF',
        uk: 'PDF'
      },
      XLS: {
        ru: 'XLS',
        en: 'XLS',
        uk: 'XLS'
      },
      DOCX: {
        ru: 'DOCX',
        en: 'DOCX',
        uk: 'DOCX'
      },
      SETTING: {
        ru: 'Настройки профиля',
        en: 'Profile settings',
        uk: 'Налаштування профілю'
      },
      EXIT: {
        ru: 'Выход',
        en: 'Logout',
        uk: 'Вихід'
      }
    },
    mainHeader: {
      CREATE_NEW: {
        ru: 'Создать новый',
        en: 'Create new',
        uk: 'Створити новий'
      },
      ALL_RELEASES: {
        ru: 'Все инфоповоды',
        en: 'All campaigns',
        uk: 'Всі інфоприводи'
      }
    },
    bodyModalAlert: {
      RECEIVE_NOTIF_NEWS: {
        ru: 'Вы будете получать уведомления о новом выходе данной новости:',
        en:
          'You will receive notifications about the new release of this campaign:',
        uk:
          'Ви будете отримувати сповіщення про нові виході даного інфопривода:'
      },
      ADRESS: {
        ru: 'Адресс для рассылки',
        en: 'E-mail',
        uk: 'Адреса для розсилки'
      },
      PLACEHOLDER_ADRESS: {
        ru: 'Введите адресс',
        en: 'Enter your e-mail',
        uk: 'Введіть е-mail'
      },
      CANCEL: {
        ru: 'Отменить',
        en: 'Cancel',
        uk: 'Скасувати'
      },
      SUBSCRIBE: {
        ru: 'Подписаться',
        en: 'Subscribe',
        uk: 'Підписатись'
      },
      DELIVERY: {
        ru: 'Тип доставки',
        en: 'Delivery type',
        uk: 'Тип доставки'
      }
    },
    release: {
      DEL_ARTICLES: {
        ru: 'Удаленные выходы',
        en: 'Deleted publications',
        uk: 'Видалені виходи'
      },
      LOOCK_STATISTICS: {
        ru: 'Смотреть статистику',
        en: 'View statistics',
        uk: 'Дивитися статистику'
      },
      COUNT_ARTICLES: {
        ru: 'Количество выходов инфоповода',
        en: 'Number of publications',
        uk: 'Кількість виходів інфоприводу'
      },
      Q_MISSING_SOMETHING: {
        ru: 'Мы что-то упустили?',
        en: 'Are we missing something?',
        uk: 'Ми щось пропустили?'
      },
      Q_WANT_DEL_RELEASE: {
        ru: 'Вы уверены, что хотите удалить версию инфоповода?',
        en: 'Are you sure you want to delete the campaign?',
        uk: 'Ви впевнені, що хочете видалити інфопривід?'
      },
      Q_WANT_DEL_ARTICLE: {
        ru: 'Вы уверенны, что хотите удалить выход инфоповода?',
        en: 'Are you sure you want to delete the publication?',
        uk: 'Ви впевнені, що хочете видалити вихід інфоприводу?'
      },
      TOTAL_AUDIENCE: {
        ru: 'Суммарная аудитория источников за месяц',
        en: 'Total monthly audience of sources',
        uk: 'Сумарна аудиторія джерел за місяць'
      },
      NUMBER_VIEWS: {
        ru: 'Суммарное среднее кол-во просмотров',
        en: 'The total average number of views',
        uk: 'Сумарна середня кількість переглядів'
      },
      LIST_OF_OUTPUTS: {
        ru: 'Список выходов',
        en: 'List of publications',
        uk: 'Перелік виходів'
      },
      ADD_OUTPUT: {
        ru: 'Добавить выход',
        en: 'Add publications',
        uk: 'Додати вихід'
      },
      ADD: {
        ru: 'Добавить',
        en: 'Add',
        uk: 'Додати'
      },
      DELETED: { ru: 'Удалённые', en: 'Deleted', uk: 'Видалені' },
      SHOW_ALL: { ru: 'Показать все', en: 'Show all', uk: 'Показати всі' },
      SHOW_FOUR: { ru: 'Свернуть', en: 'Minimize', uk: 'Згорнути' },
      DELETE_VARIANT: {
        ru: 'Удалить вариант',
        en: 'Delete version',
        uk: 'Видалити варіант'
      },
      DELETED_OPTIONS: {
        ru: 'Удаленные варианты',
        en: 'Deleted versions',
        uk: 'Видалені варіанти'
      },
      RENAME_OPTIONS: {
        ru: 'Переименовать вариант',
        en: 'Rename version',
        uk: 'Перейменувати варіант'
      },
      RENAME_CAMPAIGN: {
        ru: 'Переименовать инфоповод',
        en: 'Rename campaign',
        uk: 'Перейменувати інфопривід'
      }
    },
    addOutputs: {
      ENTER_LINK: {
        ru: 'Вставьте ссылку и мы быстро все исправим!',
        en: 'Insert the link and we will fix everything quickly!',
        uk: 'Вставте посилання і ми швидко все виправимо!'
      },
      FOUND: { ru: 'Найдено:', en: 'Found:', uk: 'Знайдено:' },
      NOT_FOUND: {
        ru: 'Не найдено. Попробуйте проверить ссылку',
        en: 'Not found. Try to check the link',
        uk: 'Не знайдено. Спробуйте перевірити посилання'
      },
      NOT_FOUND_TEXT: {
        ru: 'Не найдено. Попробуйте проверить текст',
        en: 'Not found. Try to change the text',
        uk: 'Не знайдено. Спробуйте перевірити текст'
      }
    },
    alertDelPressRelase: {
      CANCEL: { ru: 'Отменить', en: 'Cancel', uk: 'Скасувати' },
      DELETE: { ru: 'Удалить', en: 'Delete', uk: 'Видалити' }
    },
    LoginPage: {
      SIGN_IN: { ru: 'Войдите', en: 'Sign in', uk: 'Увійдіть' },
      ACCOUNT: {
        ru: 'в свой аккаунт',
        en: 'to your account',
        uk: 'в свій аккаунт'
      },
      USERNAME: {
        ru: 'Имя пользователя',
        en: 'Username',
        uk: "Ім'я користувача"
      },
      PASSWORD: { ru: 'Пароль', en: 'Password', uk: 'Пароль' },
      ENTER: { ru: 'Войти', en: 'Log in', uk: 'Увійти' },
      Q_FORGOT_PASS: {
        ru: 'Забыли пароль?',
        en: 'Forgot password??',
        uk: 'Забули пароль?'
      },
      RESET_TEXT: {
        ru:
          'Введите свой адрес электронной почты, и мы пришлем вам ссылку для сброса пароля',
        en:
          'Enter your email address and we will send you a link to reset your password',
        uk:
          'Введіть свою адресу електронної пошти, і ми надішлемо вам посилання для відновлення пароля'
      },
      SEND_LINK: {
        ru: 'Отправить ссылку',
        en: 'Send a link',
        uk: 'Надіслати посилання'
      },
      RESEND_TEXT: {
        ru:
          'На указанный адрес электронной почты, было отправлено письмо с инструкциями по сбросу пароля. Если вы не получили электронное письмо, убедитесь, что ввели корректную почту и проверьте папку со спамом. ',
        en:
          "We've sent password reset instructions to your email address. If no email is received within ten minutes, check that the submitted address is correct or check your spam folder.",
        uk:
          'На вказану адресу електронної пошти, було відправлено лист з інструкціями щодо відновлення паролю. Якщо ви не отримали електронного листа, переконайтеся, що ввели коректну пошту або перевірте папку зі спамом.'
      },
      RESEND_LINK: {
        ru: 'Отправить еще раз',
        en: 'Send again',
        uk: 'Відправити ще раз'
      },
      CANCEL_RESET_PASS: {
        ru: 'Отменить',
        en: 'Cancel',
        uk: 'Відмінити'
      },
      SUBSCRIBE: {
        ru: 'Оформить подписку',
        en: 'Subscribe',
        uk: 'Оформити підписку'
      },
      ENTER_EMAIL: {
        ru: 'Введите адрес электронной почты',
        en: 'Enter your e-mail',
        uk: 'Введіть адресу електронної пошти'
      }
    },
    userProfile: {
      SETTING_PROFILE: {
        ru: 'Настройки профиля',
        en: 'Profile settings',
        uk: 'Налаштування профілю'
      },
      SETTING_AUTH: {
        ru: 'Настройки аутентификации',
        en: 'Authentication settings',
        uk: 'Налаштування аутентифікації'
      },
      PERSONAL_SETTING: {
        ru: 'Персональные настройки',
        en: 'Personal settings',
        uk: 'Персональні налаштування'
      },
      ENTER_USERNAME: {
        ru: 'Введите имя пользователя',
        en: 'Enter your username',
        uk: "Введіть ім'я користувача"
      },
      CLARIFICATION: {
        ru:
          'Обязательное поле. Не более 30 символов. Только буквы, цифры и символы @/./+/-/_.',
        en:
          'Required field. No more than 30 characters. Only letters, numbers and symbols @ /. / + / - / _.',
        uk:
          "Обов'язкове поле. Не більше 30 символів. Тільки букви, цифри і символи @ /. / + / - / _."
      },
      LANGUAGE: {
        ru: 'Язык',
        en: 'Language',
        uk: 'Мова'
      },
      OLD_PASS: {
        ru: 'Старый пароль',
        en: 'Old password',
        uk: 'Старий пароль'
      },
      ENTER_OLD_PASS: {
        ru: 'Введите старый пароль',
        en: 'Enter your old password',
        uk: 'Введіть старий пароль'
      },
      FIRSTNAME: {
        ru: 'Имя',
        en: 'First name',
        uk: "Ім'я"
      },
      ENTER_FIRSTNAME: {
        ru: 'Введите имя',
        en: 'Enter your first name',
        uk: "Введіть ім'я"
      },
      LASTNAME: {
        ru: 'Фамилия',
        en: 'Last name',
        uk: 'Прізвище'
      },
      ENTER_LASTNAME: {
        ru: 'Введите фамилию',
        en: 'Enter your last name',
        uk: 'Введіть прізвище'
      },
      TIMEZONE: {
        ru: 'Часовой пояс',
        en: 'Timezone',
        uk: 'Часовий пояс'
      },
      EMAIL: {
        ru: 'Адрес электронной почты',
        en: 'E-mail address',
        uk: 'Адреса електронної пошти'
      },
      ENTER_EMAIL: {
        ru: 'Введите адрес электронной почты',
        en: 'Enter your e-mail',
        uk: 'Введіть адресу електронної пошти'
      }
    },
    createFirstRelease: {
      ADD_TITLE: {
        ru: 'Добавьте название к вашему инфоповоду',
        en: 'Add a title to your campaign',
        uk: 'Додайте назву до вашого інфоприводу'
      },
      ADD_VERSION_TITLE: {
        ru: 'Добавьте название к новому варианту инфоповода',
        en: 'Add a title to the new version of the campaign',
        uk: 'Додайте назву до нового варіанту інфопривода'
      },
      ADD_TITLE_HEADING: {
        ru: 'Добавьте название',
        en: 'Add a title',
        uk: 'Додайте назву'
      },
      ADD_HEADING: {
        ru: 'Добавьте заголовок',
        en: 'Add a headline',
        uk: 'Додайте заголовок'
      },

      EDIT_TEXT: {
        ru: 'Редактировать текст',
        en: 'Edit text',
        uk: 'Редагувати текст'
      },
      ADD_NEW_VERSION: {
        ru: 'Добавьте новый вариант инфоповода',
        en: 'Add a new version of the campaign',
        uk: 'Додайте новий варіант інфоприводу'
      },
      CREATE_RELEASE: {
        ru: 'Создайте новый инфоповод',
        en: 'Create a new campaign',
        uk: 'Створіть новий інфопривід'
      },
      ADD_TEXT: {
        ru: 'Или добавьте ниже текст вашего инфоповода:',
        en: 'Or add your campaign text below:',
        uk: 'Або додайте нижче текст вашого інфопривода:'
      },
      SEARCHING_RELEASE: {
        ru: 'Идет поиск вашего инфоповода',
        en: 'Searching for your campaign',
        uk: 'Йде пошук вашого інфопривода'
      },
      FOUND: { ru: 'Найдено:', en: 'Found:', uk: 'Знайдено:' },
      NOT_FOUND: {
        ru: 'Не найдено! Попробуйте воспользоваться поиском по тексту',
        en: 'Not found! Try using text search',
        uk: 'Не знайдено! Спробуйте скористатися пошуком по тексту'
      },
      NOT_FOUND_TEXT: {
        ru: 'Мы не нашли инфоповодов с данным текстом',
        en: 'We did not find any campaign with this text',
        uk: 'Ми не знайшли інфоприводів з даним текстом'
      },
      NAME: { ru: 'Название', en: 'Name', uk: 'Назва' },
      TITLE: { ru: 'Заголовок', en: 'Title', uk: 'Заголовок' },
      TEXT: {
        ru: 'Текст инфоповода',
        en: 'Campaign text',
        uk: 'Текст інфопривода'
      },
      CANCEL: { ru: 'Отменить', en: 'Cancel', uk: 'Скасувати' },
      SEARCH: { ru: 'Поиск', en: 'Search', uk: 'Пошук' },
      SAVE: { ru: 'Сохранить', en: 'Save', uk: 'Зберегти' }
    },
    groupsRelease: {
      Q_SURE_DEL: {
        ru: 'Вы уверенны, что хотите удалить инфоповод?',
        en: 'Are you sure you want to delete the campaign?',
        uk: 'Ви впевнені, що хочете видалити інфопривід?'
      },
      RECEIVE_NOTIF: {
        ru: 'Получать уведомления',
        en: 'Receive notifications',
        uk: 'Отримувати сповіщення'
      },
      DEL_GROUPS: {
        ru: 'Удаленные инфоповоды',
        en: 'Deleted campaigns',
        uk: 'Видалені інфоприводи'
      }
    },
    alertDelGroup: {
      CANCEL: { ru: 'Отменить', en: 'Cancel', uk: 'Скасувати' },
      DELETE: { ru: 'Удалить', en: 'Delete', uk: 'Видалити' }
    },
    coincidencesPopap: {
      MATCH_TEXT: {
        ru: 'Совпадение текста',
        en: 'Match the text',
        uk: 'Збіг тексту'
      },
      NUMBER: { ru: 'Выход №', en: 'Publication #', uk: 'Вихід №' }
    },
    chipsButton: {
      OPTION: { ru: 'Вариант', en: 'Version', uk: 'Варіант' }
    },
    chipsButtonAll: {
      ALL: { ru: 'Все', en: 'All', uk: 'Всі' }
    },
    chipsSelect: {
      ALL_RELEASES: {
        ru: 'Все инфоповоды',
        en: 'All campaigns',
        uk: 'Всі інфоприводи'
      },
      DELETED: { ru: 'Удаленные', en: 'Deleted', uk: 'Видалені' },
      CREATE_NEW_RELEASE: {
        ru: 'Создать новый инфоповод',
        en: 'Create a new campaign',
        uk: 'Створити новий інфопривід'
      }
    },
    favoriteWidget: {
      RELEASES: { ru: 'Инфоповод', en: 'Campaign', uk: 'Інфопривід' },
      MAX_AUDIENCE: {
        ru: 'с самым большим количеством просмотров',
        en: 'with the most views',
        uk: 'з найбільшою кількістю переглядів'
      },
      MAX_COUNT_OUTPUTS: {
        ru: 'с самым большим количеством выходов',
        en: 'with the largest number of publications',
        uk: 'з найбільшою кількістю виходів'
      }
    },
    navRelease: {
      ADD_OPTION: {
        ru: 'Добавить вариант',
        en: 'Add version',
        uk: 'Додати варіант'
      }
    },
    releaseText: {
      RELEASE: { ru: 'Инфоповод', en: 'Campaign', uk: 'Інфопривід' }
    },
    searchField: {
      ENTER_LINK: {
        ru: 'Вставьте ссылку',
        en: 'Insert the link',
        uk: 'Вставте посилання'
      },
      SEARCH: { ru: 'Поиск', en: 'Search', uk: 'Пошук' }
    },
    textField: {
      ENTER_LINK: {
        ru: 'Вставьте ссылку',
        en: 'Insert the link',
        uk: 'Вставте посилання'
      }
    },
    textRedactor: {
      NAME: { ru: 'Название', en: 'Name', uk: 'Назва' },
      HEADING: { ru: 'Заголовок', en: 'Title', uk: 'Заголовок' },
      OK: { ru: 'Готово', en: 'Done', uk: 'Готово' },
      SAVE: { ru: 'Сохранить', en: 'Save', uk: 'Зберегти' },
      CANCEL: { ru: 'Отменить', en: 'Cancel', uk: 'Скасувати' }
    },
    widgetRelease: {
      OPTION: { ru: 'Вариант ', en: 'Version', uk: 'Варіант' },
      ADD: { ru: 'Добавить', en: 'Add', uk: 'Додати' }
    },
    widgetReleaseWithRedactor: {
      EDIT: { ru: 'Редактировать', en: 'Edit', uk: 'Редагувати' },
      ADD: { ru: 'Добавить', en: 'Add', uk: 'Додати' },
      CANCEL: { ru: 'Отменить', en: 'Cancel', uk: 'Скасувати' }
    },
    table: {
      NUMBER: { ru: '№', en: '№', uk: '№' },
      HEADING: { ru: 'Заголовок', en: 'Title', uk: 'Заголовок' },
      DATE: { ru: 'Дата выхода', en: 'Release date', uk: 'Дата виходу' },
      URL: { ru: 'Источник', en: 'Source', uk: 'Джерело' },
      ATTENDANCE: { ru: 'Аудитория', en: 'Audience', uk: 'Аудиторія' },
      VIEWS_COUNT: { ru: 'Просмотры', en: 'Views', uk: 'Перегляди' },
      RATIO: { ru: 'Текст', en: 'Text', uk: 'Текст' },
      TITLE: {
        ru: 'Название/Первый выход',
        en: 'Title/First publication',
        uk: 'Назва/Перший вихід'
      },
      QUANTITY: {
        ru: 'Кол-во выходов',
        en: 'Number of publication',
        uk: 'К-ть виходів'
      },
      NOTIF: { ru: '', en: '', uk: '' },
      DELL: { ru: '', en: '', uk: '' },
      REESTABLISH: { ru: 'Восстановить', en: 'Restore', uk: 'Відновити' },
      TITLE_ONLY: {
        ru: 'Название',
        en: 'Title',
        uk: 'Назва'
      }
    },
    tooltip: {
      RECEIVE_NOTIFICATION: {
        ru: 'Получать уведомления о новом выходе данной новости',
        en: 'Receive notifications about a new release of news',
        uk: 'Отримувати повідомлення про нові виходи даної новини'
      },
      RECEIVE_NOTIF: {
        ru: 'Получать уведомления о новом выходе данного инфоповода',
        en: 'Receive notifications about a new release of campaign',
        uk: 'Отримувати повідомлення про нові виходи даного інфопривода'
      },
      UNSUBSCRIBE: { ru: 'Отписаться', en: 'Unsubscribe', uk: 'Відписатись' },
      INFO_NAME_RELEASE: {
        ru:
          'Название вашего материала, под которым он будет отображаться в списке всех ваших инфоповодов.',
        en:
          'The name of your campaign, by which it will be in your list of all campaigns.',
        uk:
          'Назва вашого матеріалу з якою він відображатиметься у переліку всіх ваших інфоприводів'
      },
      RETURN_OUTPUTS: {
        ru: 'Вернуть в список выходов',
        en: 'Return to publication list',
        uk: 'Повернути в список виходів'
      },
      RETURN_OPTIONS: {
        ru: 'Вернуть в список вариантов',
        en: 'Return to version list',
        uk: 'Повернути в список варіантів'
      },
      DEL_GROUP: {
        ru: 'Удалить инфоповод',
        en: 'Delete campaign',
        uk: 'Видалити інфопривід'
      },
      DEL_OPTION: {
        ru: 'Удалить вариант',
        en: 'Delete version',
        uk: 'Видалити варіант'
      },
      DEL_OUTPUT: {
        ru: 'Удалить выход',
        en: 'Delete publication',
        uk: 'Видалити вихід'
      },
      PERCENT: {
        ru: 'Посмотреть текст новости',
        en: 'View news text',
        uk: 'Переглянути текст новини'
      },
      AUDIENCE: {
        ru: 'Суммарная аудитория источника за месяц',
        en: 'Monthly source audience',
        uk: 'Місячна аудиторія джерела'
      },
      VIEWING: {
        ru: 'Среднее количество просмотров материала на этом источнике',
        en: 'Average views on this source',
        uk: 'Середня кількість переглядів новини на цьому джерелі'
      },
      TEXT: {
        ru:
          '% совпадения текста новости с той, что была указана при создании инфоповода',
        uk:
          '% збігу тексту новини з тією, що була вказана при створенні інфоприводу',
        en:
          '% coincidence of the news text with the one that was specified when creating the news feed'
      }
    },
    diagramChart: {
      'source type': {
        ru: 'Тип СМИ',
        en: 'Media types',
        uk: 'Тип ЗМІ'
      },
      'source level': {
        ru: 'Уровень СМИ',
        en: 'Source level',
        uk: 'Рівень ЗМІ'
      },
      'source subject': {
        ru: 'Тематика источников',
        en: 'Source subjects',
        uk: 'Тематика джерел'
      },
      'source country': {
        ru: 'Страна упоминаний',
        en: 'Country',
        uk: 'Країна згадувань'
      },
      'source region': {
        ru: 'Регион упоминаний',
        en: 'Region',
        uk: 'Регіон згадувань'
      }
    },
    roundFn: {
      K: {
        ru: 'тыс.',
        en: 'K',
        uk: 'тис.'
      },
      M: {
        ru: 'млн.',
        en: 'M',
        uk: 'млн.'
      }
    },
    notif: {
      DOWNLOAD: {
        ru: 'Ваш отчет формируется',
        en: 'Generating report. Please wait.',
        uk: 'Ваш звіт формується'
      },
      COPY_LINK: {
        ru: 'Cсылка скопирована',
        en: 'The link has been copied to clipboard',
        uk: 'Посилання скопійоване'
      },
      OUTPUT_ADDED: {
        ru: 'Выход добавлен',
        en: 'Publication added',
        uk: 'Вихід доданий'
      },
      OPTION_ADDED: {
        ru: 'Вариант добавлен',
        en: 'Version added',
        uk: 'Варіант доданий'
      },
      CAMPAIGN_ADDED: {
        ru: 'Инфоповод добавлен',
        en: 'Campaign added',
        uk: 'Інфопривід доданий'
      },
      CHART_DOWNLOADING: {
        ru: 'Идет загрузка графика',
        en: 'Loading chart',
        uk: 'Триває завантаження графіку'
      },
      CHART_OK: {
        ru: 'График загружен',
        en: 'Chart loaded',
        uk: 'Графік завантажений'
      },
      PASS_CHANGE: {
        ru: 'Пароль успешно изменен',
        en: 'Your password has been changed successfully',
        uk: 'Пароль успішно змінений'
      },
      SUBSCRIBE_OK: {
        ru: 'Подписка создана',
        en: 'Subscription created',
        uk: 'Підписка створена'
      },
      OUTPUT_DELL: {
        ru: 'Выход удалено',
        en: 'Publicationn removed',
        uk: 'Вихід видалено'
      },
      VERSION_DELL: {
        ru: 'Вариант удалено',
        en: 'Version removed',
        uk: 'Варіант видалено'
      },
      CAMPAIGN_DELL: {
        ru: 'Инфоповод удалено',
        en: 'Campaign removed',
        uk: 'Інфопривід видалено'
      }
    },
    bodyLink: {
      SHARE: {
        ru: 'Поделиться',
        en: 'Share',
        uk: 'Поділитись'
      },
      CLICK_COPY: {
        ru: 'Нажмите, чтобы скопировать ссылку',
        en: 'Click to copy link',
        uk: 'Натисніть, щоб скопіювати посилання'
      }
    },
    error: {
      ERR_USERNAME: {
        ru: 'Неверное имя пользователя',
        en: 'Incorrect username',
        uk: "Неправильне ім'я користувача"
      },
      ALREADY_EXISTS: {
        ru: 'Email already exists',
        en: 'Email already exists',
        uk: 'Email already exists'
      },
      HUB_AUTH_ERROR: {
        ru: 'Unable to log in using hub',
        en: 'Unable to log in using hub',
        uk: 'Unable to log in using hub'
      },
      ERR_PASS: {
        ru: 'Неверный пароль',
        en: 'Incorrect password login',
        uk: 'Неправильний пароль'
      },
      ERR_TRIAL: {
        ru: 'У вас закончился тестовый период',
        en: 'Your trial has ended',
        uk: 'У вас закінчився тестовий період'
      },
      ERR_SERVER: {
        ru: 'Проблемы с сервером, попробуйте еще раз',
        en: 'Server is not responding, please try again',
        uk: 'Проблеми з сервером, спробуйте ще раз'
      },
      ERR_DIFFERENT_PASS: {
        ru: 'Пароли не совпадают',
        en: 'Passwords do not match',
        uk: 'Паролі не співпадають'
      },
      ERR_REGISTRATION: {
        ru: 'Мы не нашли зарегистрированных пользователей с этой почтой',
        en: 'We have not found registered users with this e-mail',
        uk: 'Ми не знайшли зареєстрованих користувачів з цією поштою'
      },
      ERR_LINK: {
        ru:
          'Ссылка на сброс пароля недействительна. Пожалуйста, запросите новый сброс пароля.',
        en:
          'Link to reset password is invalid. Please request a new password reset.',
        uk:
          'Посилання на скидання пароля недійсне. Будь ласка, пройдіть процедуру скидання пароля заново.'
      }
    },
    passwordReset: {
      NEW_PASS: {
        ru: 'Новый пароль',
        en: 'New password',
        uk: 'Новий пароль'
      },
      CONFIRM_PASS: {
        ru: 'Подтверждение нового пароля',
        en: 'Confirm new password',
        uk: 'Підтвердження нового пароля'
      },
      ENTER_NEW_PASS: {
        ru: 'Введите новый пароль',
        en: 'Enter a new password',
        uk: 'Введіть новий пароль'
      },
      SAVE: { ru: 'Сохранить', en: 'Save', uk: 'Зберегти' }
    },
    delGroups: {
      NOT_DELETED: {
        ru: 'У вас нет удаленных инфоповодов',
        en: "You don't have any deleted campaigns",
        uk: 'У вас немає видалених інфоприводів'
      },
      CLEAR: {
        ru: 'Очистить',
        en: 'Clear deleted campaigns',
        uk: 'Очистити'
      }
    },
    statusTestUser: {
      TEST_END: {
        ru: 'До конца тестового режима',
        en: 'Your trial access to',
        uk: 'До кінця тестового режиму'
      },
      TEST_LEFT: {
        ru: 'осталось:',
        en: 'will end in:',
        uk: 'залишилося:'
      },
      DAYv1: {
        ru: 'день',
        en: 'day',
        uk: 'день'
      },
      DAYv2: {
        ru: 'дня',
        en: 'days',
        uk: 'дні'
      },
      DAYv3: {
        ru: 'дней',
        en: 'days',
        uk: 'днів'
      },
      GET_ACCESS: {
        ru: 'Получить полный доступ',
        en: 'Get full access',
        uk: 'Отримати повний доступ'
      },
      SUBSCRIPTION: {
        ru: 'Оформите подписку на CheckIt',
        en: 'Subscribe to CkeckIt',
        uk: 'Оформіть підписку на CkeckIt'
      },
      TEXT_ACCESS_TOP_ONE: {
        ru: 'В тестовом режиме CheckIt,',
        en: 'In trial mode of CheckIt,',
        uk: 'У тестовому режимі CheckIt,'
      },
      TEXT_ACCESS_TOP_TWO: {
        ru: 'вы можете проверить максимум',
        en: 'you can check a maximum of',
        uk: 'ви можете перевірити максимум'
      },
      TEXT_ACCESS_TOP_THREE: {
        ru: '4 информационных повода.',
        en: '4 campaigns.',
        uk: '4 інформаційних привода.'
      },
      TEXT_ACCESS_BOTTOM: {
        ru:
          'Чтобы получить доступ к неограниченному количеству проверок нажмите кнопку "Оформить подписку" и наш менеджер свяжется с вами в ближайшее время.',
        en:
          'To get access to an unlimited number of checks, click the "Subscribe" button and our manager will contact you shortly.',
        uk:
          "Щоб отримати доступ до необмеженої кількості перевірок натисніть кнопку 'Оформити підписку' і наш менеджер зв'яжеться з вами найближчим часом."
      },
      CANCEL: {
        ru: 'Отменить',
        en: 'Cancel',
        uk: 'Скасувати'
      },
      SUBSCRIBE: {
        ru: 'Оформить подписку',
        en: 'Subscribe',
        uk: 'Оформити підписку'
      },
      REQUEST_SENT: {
        ru: 'Спасибо! Ваш запрос отправлен!',
        en: 'Thank you! Your request has been sent!',
        uk: 'Дякуємо! Ваш запит відправлено!'
      },
      WILL_CONTACT: {
        ru: 'В ближайшее время с вами свяжется наш менеджер',
        en: 'Our manager will contact you shortly',
        uk: "Найближчим часом з вами зв'яжеться наш менеджер"
      }
    }
  }
};
